// import { numberWithoutComma } from '@/libs/helper'
// import { numberWithCommas } from '@/utils'

export default {
  // data() {
  //   return {
  //     numberWithCommas,
  //     numberWithoutComma,
  //   }
  // },
  methods: {
    getColor(color) {
      return getComputedStyle(document.documentElement)
        .getPropertyValue(`--${color}`)
        .trim()
    },
    citizenship() {
      return this.$store.state.auth?.user?.citizenship?.name.toLowerCase()
    },
  },
}
